import { render, staticRenderFns } from "./partitaIva.vue?vue&type=template&id=70c91cc0"
import script from "./partitaIva.vue?vue&type=script&lang=js"
export * from "./partitaIva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports